// de_pms_common.ts
// Elementy wspólne dla wszystkich ekranów PMS — statusy, akcje, etykiety
// Importuj ten plik w każdym ekranowym pliku tłumaczeń zamiast powielać te same klucze.

export const dePmsCommon = {

  // ── Statusy pokoi ──────────────────────────────────────────────────────────
  roomStatus: {
    available:    "Verfuegbar",
    occupied:     "Belegt",
    dirty:        "Schmutzig",
    clean:        "Sauber",
    cleaning:     "In Reinigung",
    inspected:    "Geprueft",
    blocked:      "Gesperrt",
    outOfOrder:   "Ausser Betrieb",
    outOfService: "Ausser Dienst",
    unassigned:   "Nicht zugewiesen",
    reserved:     "Reserviert",
    maintenance:  "Wartung",
  },

  // ── Statusy rezerwacji ─────────────────────────────────────────────────────
  reservationStatus: {
    confirmed:  "Bestaetigt",
    inHouse:    "In-house",
    cancelled:  "Storniert",
    checkedOut: "Abgereist",
    noShow:     "No-show",
    waitlist:   "Warteliste",
    pending:    "Ausstehend",
    planned:    "Geplant",
    completed:  "Abgeschlossen",
    booked:     "Gebucht",
    active:     "Aktiv",
    all:        "Alle",
  },

  roomCalendar: {
    allTypes: "Alle Zimmertypen",
    allFloors: "Alle Etagen",
    floor: "Etage {{floor}}",
    filterByFloor: "Nach Etage filtern",
    clearFilters: "Zurücksetzen",
    checkedOut: "Ausgecheckt",
    checkedIn: "Eingecheckt",
    cancelledNoShow: "Storniert / Nicht angereist",
    showCheckedOut: "Ausgecheckte Reservierungen anzeigen",
    hideCheckedOut: "Ausgecheckte Reservierungen ausblenden",
    reservationLegend: "Legende der Reservierungsstatus und Zimmerfilter",
    roomNumberPlaceholder: "Zimmernr.",
    searchRoomNumber: "Nach Zimmernummer suchen",
  },

  // ── Ważność / Priorytet ────────────────────────────────────────────────────
  severity: {
    critical: "Kritisch",
    high:     "Hoch",
    medium:   "Mittel",
    low:      "Niedrig",
  },

  // ── Przyciski i akcje ──────────────────────────────────────────────────────
  actions: {
    save:        "Speichern",
    saving:      "Speichern...",
    cancel:      "Abbrechen",
    cancelling:  "Stornieren...",
    close:       "Schliessen",
    closing:     "Schliessen...",
    edit:        "Bearbeiten",
    delete:      "Loeschen",
    confirm:     "Bestaetigen",
    approve:     "Genehmigen",
    create:      "Erstellen",
    creating:    "Erstellen...",
    add:         "Hinzufuegen",
    adding:      "Hinzufuegen...",
    back:        "Zurueck",
    search:      "Suchen",
    filter:      "Filtern",
    refresh:     "Aktualisieren",
    download:    "Herunterladen",
    preview:     "Vorschau",
    print:       "Drucken",
    send:        "Senden",
    modify:      "Aendern",
    viewAll:     "Alle anzeigen",
    viewDetails: "Details anzeigen",
    opening:     "Oeffnen...",
    set:         "Setzen",
  },

  // ── Stany komunikatów ──────────────────────────────────────────────────────
  state: {
    loading:   "Laden...",
    noData:    "Keine Daten",
    noResults: "Keine Ergebnisse",
    failed:    "Fehlgeschlagen.",
  },

  // ── Wspólne etykiety pól ───────────────────────────────────────────────────
  labels: {
    guest:        "Gast",
    guests:       "Gaeste",
    room:         "Zimmer",
    rooms:        "Zimmer",
    floor:        "Etage",
    night:        "Nacht",
    nights:       "Naechte",
    checkIn:      "Check-in",
    checkOut:     "Check-out",
    arrival:      "Anreise",
    departure:    "Abreise",
    arrivals:     "Anreisen",
    departures:   "Abreisen",
    status:       "Status",
    operations:   "Operationen",
    frontDesk:    "Rezeption",
    occupancy:    "Auslastung",
    revenue:      "Umsatz",
    billing:      "Abrechnung",
    housekeeping: "Housekeeping",
    department:   "Abteilung",
    owner:        "Verantwortlich",
    priority:     "Prioritaet",
    date:         "Datum",
    time:         "Zeit",
    total:        "Gesamt",
    notes:        "Notizen",
    invoice:      "Rechnung",
    group:        "Gruppe",
    type:         "Typ",
    rate:         "Rate",
    balance:      "Saldo",
    amount:       "Betrag",
    currency:     "Waehrung",
    name:         "Name",
    email:        "E-Mail",
    phone:        "Telefon",
    address:      "Adresse",
    country:      "Land",
    today:        "Heute",
    other:        "Andere",
    none:         "Keine",
    unassigned:   "Nicht zugewiesen",
    inHouse:      "In-house",
    readyRoom:    "Bereites Zimmer",
    noReadyRoom:  "Kein bereites Zimmer",
  },

} as const;

export default dePmsCommon;
